import React from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import "./ColorButton.scss";

const ColorButton = (props) => {
  const {
    text,
    size = "medium",
    color = "#E63050",
    disabled = false,
    loading = false,
    path,
    onClick,
    type = "button",
    icon,
  } = props;

  const navigate = useNavigate();

  const getSizeStyle = () => {
    switch (size) {
      case "small":
        return { width: "100px" };
      case "medium":
        return { width: "150px" };
      case "large":
        return { width: "200px" };
      case "full":
        return { width: "100%" };
      case "fit":
        return { width: "fit-content" };
      default:
        return {};
    }
  };

  const handleClick = (e) => {
    if (disabled || loading) return;

    if (path) {
      navigate(path);
    }

    if (onClick) {
      onClick(e);
    }
  };

  const sizeStyle = getSizeStyle();

  return (
    <button
      type={type}
      className={`colored ${disabled ? "disabled" : ""}`}
      style={{
        ...sizeStyle,
        color: color,
        opacity: disabled || loading ? 0.5 : 1,
        cursor: disabled || loading ? "not-allowed" : "pointer",
      }}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <>
          {icon && icon}
          {text}
        </>
      )}
    </button>
  );
};

export default ColorButton;
